import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { IconEnum } from "@evc/web-components";

@Component({
  selector: "app-common-error-message-dialog",
  templateUrl: "./common-error-message-dialog.component.html",
  styleUrls: ["./common-error-message-dialog.component.scss"],
  standalone: false
})
export class CommonErrorMessageDialogComponent implements OnInit {
  firstMessage = "";
  secondMessage = "";
  errorIcon = IconEnum.TriangleExclamation;
  constructor(
    public dialogRef: MatDialogRef<CommonErrorMessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
  ngOnInit() {
    this.firstMessage = this.data.firstMessage;
    this.secondMessage = this.data.secondMessage;
  }
}
